import { Box, InputBase, Button, styled } from "@mui/material";
import { useState } from "react";
import { getWeather } from "../services/api";

const Container = styled(Box)({
    background: '#445a6f',
    padding:10,
    borderRadius:'0 10px 0 0'
})

const Input = styled(InputBase)({
    color: '#fff',
    marginRight: 10,
    fontSize: 14,
}) 

const GetButton = styled(Button)({
    background:'#e67e22',
    width:140
})

const Form = ({ setResult }) => {
    const [data, setData] = useState({ city: '', country: '' })

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
        // console.log(data);
    }

    //to get data from the api call
    const getWeatherInfo = async () => {
        let response = await getWeather( data.city, data.country );
        setResult(response);
    }

    return (
        <Container>
            <Input 
                placeholder="City"
                onChange={(e) => handleChange(e)}
                name="city"
            />
            <Input 
                placeholder="Country"
                onChange={(e) => handleChange(e)}
                name="country"
            />
            <GetButton
                onClick={() => getWeatherInfo()}
                variant="contained"
            >Get Weather</GetButton>
        </Container>
    )
}

export default Form;